<template>
    <!-- Generato da claude — Richieste redesign Proposta A -->
    <div>
        <div class="card" v-if="arrayRichieste.length > 0">
            <div class="card-header card-header-background">
                <span class="dk-header-title">💬 Messaggi segreteria</span>
                <span class="dk-header-badge" v-if="nNuovi > 0">{{nNuovi}} nuovi</span>
            </div>
            <div class="card-body p-0">
                <div class="dk-list-item"
                    v-for="richiesta in arrayRichieste"
                    :key="richiesta.ID_RICHIESTA"
                    @click="openMessaggi(richiesta)">
                    <div class="dk-list-icon"
                        :style="richiesta.FK_ID_STATO == 0 ? '' : 'background:#f0f0f5'">
                        {{richiesta.FK_ID_STATO == 0 ? '💬' : '🔒'}}
                    </div>
                    <div class="dk-list-info">
                        <div class="dk-list-title">{{richiesta.OGGETTO}}</div>
                        <div class="dk-list-sub">
                            <span v-if="richiesta.NON_LETTI > 0" style="color:var(--dk-orange);font-weight:700">
                                {{richiesta.NON_LETTI}} nuovi messaggi dalla segreteria
                            </span>
                            <span v-else>
                                {{richiesta.FK_ID_STATO == 0 ? 'Aperta' : 'Chiusa'}}
                            </span>
                        </div>
                    </div>
                    <div class="dk-list-action">
                        <span class="badge" :class="richiesta.FK_ID_STATO == 0 ? 'badge-success' : 'badge-secondary'">
                            {{richiesta.FK_ID_STATO == 0 ? 'Aperta' : 'Chiusa'}}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="card" v-else>
            <div class="card-header card-header-background">
                <span class="dk-header-title">💬 Messaggi segreteria</span>
            </div>
            <div class="card-body p-0">
                <div class="dk-empty-state">
                    <span class="dk-empty-state-icon">💬</span>
                    Nessun messaggio dalla segreteria
                </div>
            </div>
        </div>

        <!-- Modal: cronologia messaggi -->
        <div class="modal fade" id="popUpMessaggi" role="dialog" aria-modal="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header modal-header-info">
                        <h5 class="modal-title">
                            <i class="fal fa-comments fa-fw me-1"></i>
                            {{richiestaSelezionata.OGGETTO}}
                        </h5>
                        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Chiudi"></button>
                    </div>
                    <div class="modal-body" style="max-height:60vh;overflow-y:auto">
                        <div v-for="messaggio in arrayMessaggi" :key="messaggio.ID_MESSAGGIO">
                            <div class="dk-msg-bubble" :class="getUtente(messaggio) === 'TU' ? 'from-me' : 'from-other'">
                                <div class="dk-msg-meta">
                                    {{getUtente(messaggio)}} · {{filters.formatDateTime(messaggio.DATA_MESSAGGIO)}}
                                </div>
                                {{messaggio.TESTO_MESSAGGIO}}
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer" v-if="richiestaSelezionata.FK_ID_STATO == 0">
                        <button type="button" class="btn btn-success" @click="openMessaggio()">
                            <i class="fal fa-reply fa-fw"></i> Rispondi
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal: nuova risposta -->
        <div class="modal fade" id="popUpMessaggio" role="dialog" aria-modal="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header modal-header-info">
                        <h5 class="modal-title"><i class="fal fa-reply fa-fw me-1"></i> Invia risposta</h5>
                        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Chiudi"></button>
                    </div>
                    <div class="modal-body">
                        <label class="form-label fw-bold">Messaggio</label>
                        <textarea class="form-control" rows="4" autocomplete="off"
                            placeholder="Scrivi la tua risposta..."
                            v-model="messaggioSelezionato.TESTO_MESSAGGIO"></textarea>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
                            <i class="fa fa-times fa-fw"></i> Annulla
                        </button>
                        <button type="button" class="btn btn-success" @click="inviaRisposta()">
                            <i class="fal fa-paper-plane fa-fw"></i> Invia
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'Richieste',
    data: function() {
        return {
            filters: global.filters,
            arrayRichieste: [],
            arrayMessaggi: [],
            richiestaSelezionata: {},
            messaggioSelezionato: {},
        }
    },
    computed: {
        nNuovi() {
            return this.arrayRichieste.filter(r => r.NON_LETTI > 0).length;
        },
    },
    methods: {
        getRichieste() {
            utils.ajax('deskalo/richieste', {}, (response) => {
                this.arrayRichieste = response.data;
            });
        },
        openMessaggi(richiesta) {
            this.richiestaSelezionata = utils.clone(richiesta);
            utils.ajax('as/richiesta', { ID_RICHIESTA: richiesta.ID_RICHIESTA }, (response) => {
                this.arrayMessaggi = response.data.messaggi;
                utils.ajax('as/richiesta/messaggio/letto', { ID_RICHIESTA: richiesta.ID_RICHIESTA }, () => {
                    global.$('#popUpMessaggi').modal('show');
                });
            });
        },
        getUtente(messaggio) {
            return messaggio.FK_ID_UTENTE == this.$root.utente.ID_UTENTE ? 'TU' : 'SEGRETERIA';
        },
        openMessaggio() {
            this.messaggioSelezionato = { FK_ID_RICHIESTA: this.richiestaSelezionata.ID_RICHIESTA };
            global.$('#popUpMessaggio').modal('show');
        },
        inviaRisposta() {
            utils.ajax('as/richiesta/messaggio/add', this.messaggioSelezionato, () => {
                utils.ajax('as/richiesta', { ID_RICHIESTA: this.richiestaSelezionata.ID_RICHIESTA }, (response) => {
                    this.arrayMessaggi = response.data.messaggi;
                    global.$('#popUpMessaggio').modal('hide');
                });
            });
        },
    },
    created() {
        this.getRichieste();
    },
}
</script>
